import { FC } from 'react';
import { Card, Column, Paragraph, Row } from '@wunder-mobility/ui-components';
import { BookingOverviewForm } from '@/features/booking/types';
import { MergedAvailableCategoriesData, MergedBookableCategories } from '@/features/vehicles/types';
import styles from '../../../../assets/scss/components/VehicleCategoryCard.module.scss';
import VehicleCategoryEquipmentTags from '../../../VehicleCategoryEquipmentTags';
import { useFormikContext } from 'formik';
import cn from 'classnames';
import VehicleCategoryPricingDisplay from '@/features/vehicles/components/VehicleCategoryPricingDisplay';

interface BookingVehicleCategoryCardT {
  categoryData: MergedAvailableCategoriesData | MergedBookableCategories;
}

const VehicleCategoryCard: FC<BookingVehicleCategoryCardT> = ({ categoryData }) => {
  const {
    setFieldValue,
    values: { selectedVehicleCategory },
  } = useFormikContext<BookingOverviewForm>();

  return (
    <Column sm={12}>
      <Card
        className={cn(
          styles['category-card'],
          selectedVehicleCategory === categoryData.id && styles['category-card--selected'],
        )}
        onClick={() => setFieldValue('selectedVehicleCategory', categoryData.id)}
      >
        <span className={styles['category-card__indication']} />
        <Row gapSm="sm" justify="space-between">
          <Column className={styles['category-card__image']} sm={4}>
            {categoryData.appProperties?.image && (
              <img src={categoryData.appProperties.image} alt={categoryData.name} />
            )}
          </Column>
          <Column className={styles['category-card__description']} sm={8}>
            <Paragraph marginBottom={4} weight="medium">
              {categoryData.name}
            </Paragraph>
            <Paragraph textColor="text-400" size={4}>
              {!!categoryData?.grossPrice && categoryData.currency && (
                <VehicleCategoryPricingDisplay
                  extendedPricing={categoryData?.pricing}
                  grossPrice={categoryData.grossPrice}
                  netPrice={categoryData.netPrice}
                  currency={categoryData.currency}
                />
              )}
            </Paragraph>
            {categoryData?.vehicleAttributes && (
              <VehicleCategoryEquipmentTags features={categoryData?.vehicleAttributes} />
            )}
          </Column>
        </Row>
      </Card>
    </Column>
  );
};

export default VehicleCategoryCard;
